/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeDTO,
    CardTypeDTOFromJSON,
    CardTypeDTOFromJSONTyped,
    CardTypeDTOToJSON,
} from './CardTypeDTO';
import {
    CarePrincipalDTO,
    CarePrincipalDTOFromJSON,
    CarePrincipalDTOFromJSONTyped,
    CarePrincipalDTOToJSON,
} from './CarePrincipalDTO';
import {
    PersonDTO,
    PersonDTOFromJSON,
    PersonDTOFromJSONTyped,
    PersonDTOToJSON,
} from './PersonDTO';

/**
 * 
 * @export
 * @interface CardDTO
 */
export interface CardDTO {
    /**
     * 
     * @type {string}
     * @memberof CardDTO
     */
    cardSystemId?: string;
    /**
     * 
     * @type {CardTypeDTO}
     * @memberof CardDTO
     */
    cardType?: CardTypeDTO;
    /**
     * 
     * @type {Array<PersonDTO>}
     * @memberof CardDTO
     */
    persons?: Array<PersonDTO>;
    /**
     * 
     * @type {Date}
     * @memberof CardDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardDTO
     */
    preliminaryCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardDTO
     */
    finalCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CardDTO
     */
    currentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CardDTO
     */
    amountToLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof CardDTO
     */
    cardId?: string;
    /**
     * 
     * @type {CarePrincipalDTO}
     * @memberof CardDTO
     */
    carePrincipal?: CarePrincipalDTO;
    /**
     * 
     * @type {string}
     * @memberof CardDTO
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDTO
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDTO
     */
    cardReason?: CardDTOCardReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum CardDTOCardReasonEnum {
    Validcard = 'VALIDCARD',
    Medical = 'MEDICAL',
    Hks = 'HKS'
}

export function CardDTOFromJSON(json: any): CardDTO {
    return CardDTOFromJSONTyped(json, false);
}

export function CardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'cardType': !exists(json, 'cardType') ? undefined : CardTypeDTOFromJSON(json['cardType']),
        'persons': !exists(json, 'persons') ? undefined : ((json['persons'] as Array<any>).map(PersonDTOFromJSON)),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
        'finalCardDate': !exists(json, 'finalCardDate') ? undefined : (new Date(json['finalCardDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'currentAmount': !exists(json, 'currentAmount') ? undefined : json['currentAmount'],
        'amountToLimit': !exists(json, 'amountToLimit') ? undefined : json['amountToLimit'],
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'carePrincipal': !exists(json, 'carePrincipal') ? undefined : CarePrincipalDTOFromJSON(json['carePrincipal']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'cardReason': !exists(json, 'cardReason') ? undefined : json['cardReason'],
    };
}

export function CardDTOToJSON(value?: CardDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardSystemId': value.cardSystemId,
        'cardType': CardTypeDTOToJSON(value.cardType),
        'persons': value.persons === undefined ? undefined : ((value.persons as Array<any>).map(PersonDTOToJSON)),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
        'finalCardDate': value.finalCardDate === undefined ? undefined : (value.finalCardDate.toISOString().substr(0,10)),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'currentAmount': value.currentAmount,
        'amountToLimit': value.amountToLimit,
        'cardId': value.cardId,
        'carePrincipal': CarePrincipalDTOToJSON(value.carePrincipal),
        'status': value.status,
        'registeringCareProviderId': value.registeringCareProviderId,
        'cardReason': value.cardReason,
    };
}

